import { type ReactNode, useContext } from "react";

import { Context } from "../../lib/Context";
import { type MenuItem } from "../../model/types/contextMenu";
import { Item } from "../Item/Item";
import { Menu } from "../Menu/Menu";

interface ContextMenuProps {
  contextId: string;
  children?: ReactNode;
  items?: MenuItem[];
}

export const ContextMenu = (props: ContextMenuProps) => {
  const { contextId, children, items } = props;
  const { objects } = useContext(Context);

  if (!objects.has(contextId)) {
    return null;
  }

  return (
    <Menu contextId={contextId}>
      {children ||
        items.map((item, i) => (
          <Item key={i} icon={item.icon} text={item.text} onClick={item.onClick}>
            {item.content}
          </Item>
        ))}
    </Menu>
  );
};
